var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('w-datepicker',{staticClass:"form-group",attrs:{"model":_vm.schema.resumeDate}}),(_vm.schema.comment)?_c('w-textarea',{attrs:{"model":_vm.schema.comment}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }